export default __webpack_public_path__ + "static/media/choose-1.bd98e1aa.png";